import { db } from "@react-native-firebase/database";
import Pic from "core/Pic";
import { NavProps } from "core/interfaces";
import navhelper from "core/navhelper";
import { get, ref, set, update } from "firebase/database";
import { useEffect, useRef, useState } from "react";
import { Dimensions, Image, Platform, Text, TextInput, TouchableOpacity, View } from "react-native";
import { MOBILE_VIEW_WIDTH } from "res/constants";
import rating_star_selected from "res/svgs/rating.svg";
import rating_star_not_selected from "res/svgs/rating_not_selected.svg";
import Dialog from "src/components/Dialog";
import Loader from "src/components/Loader";
import RatingField from "src/components/RatingField";
import { formatDate, formatDateWithLocalTimeZone, getCurrentDate } from "src/utils/Date&TimeUtils";
import Menu from "./Menu";
import styles from "./styles/ReviewSubmissionScreen";
import { title } from "process";

const ReviewSubmissionScreen = ({ review,mode}: NavProps) => {
  const [displayCategory,setDisplayCategory]=useState({})
  const [showLoader, setShowLoader] = useState(false);
  const [showSubmissionToast, setSubmissionToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const screenWidth = Dimensions.get("window").width;
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [questionsList, setQuestionsList] = useState(null);
  const [answers, setAnswers] = useState({});
  const [rating, setRating] = useState({});
  const [reviewsResult, setReviewsResult] = useState({});
  const renderStars = (rating:number) => {
    const stars = [];
    let Comp = Platform.OS === 'web' ? Image : Pic;
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <TouchableOpacity key={i}>
          <Comp
            source={
              rating >= i ? rating_star_selected : rating_star_not_selected
            }
            style={styles.ratingstar}
          />
        </TouchableOpacity>
      );
    }
    return stars;
  };
  const fetchQuestions = async () => {
    try {
      setShowLoader(true);
      const dbRef = ref(db, `questionnaire/${review.ReviewerRole}`);
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        const resultObject = snapshot.val();
        console.log('Questions ',resultObject);
        const cleanedData = {};
        for (const key in resultObject) {
          if (Array.isArray(resultObject[key])) {
            const filteredArray = resultObject[key].filter(item => item.trim() !== '');
            if (filteredArray.length > 0) {
              cleanedData[key] = filteredArray;
            }
          } else {
            cleanedData[key] = resultObject[key];
          }
        }
  
        console.log('Cleaned Questions ', cleanedData);
        setQuestionsList(cleanedData);
        setQuestionsList(cleanedData);
        const dataObject = deepCopy(cleanedData);
        Object.keys(dataObject).forEach(key => {
          if (Array.isArray(dataObject[key])) {
            dataObject[key] = [];
          }
        });
        const ratingObject = {};
      Object.keys(cleanedData).forEach(key => {
        if (key !== 'title') {
          ratingObject[`${key}Rating`] = [];
        }
      });
        console.log('dataQuestions ', dataObject);
        setRating(ratingObject);
        setAnswers(dataObject);
        const initialDisplayCategory = {};
        Object.keys(cleanedData).forEach(key => {
          if (key !== 'title') {
            initialDisplayCategory[key] = true; 
          }
        });
        setDisplayCategory(initialDisplayCategory);
        setShowLoader(false);
      }
      else
      {
       setSubmissionToast(true)
        setToastMessage('No Question Available')
        setShowLoader(false)
      }
    } catch (error) {
      console.log("Error:", error);
      setShowLoader(false);
    }
  };
  function deepCopy(obj) {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => deepCopy(item));
    }

    const copiedObj = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        copiedObj[key] = deepCopy(obj[key]);
      }
    }

    return copiedObj;
  }
  useEffect(() => {
    if(review.status==='Saved')
{
  fetchReviewSubmission(review.id)
}
else{
    console.log('MODE IS ',mode)
    if(mode&&mode==='Edit'){
    fetchQuestions();
  }
    else if(mode&&mode==='View')
      {
        fetchReviewSubmission(review.id)
      }}
  }, []);

  const onRatingChange = (category: string, value: any, index: any) => {
    console.log("value", value, "index", index, "category", category);
    const temp = deepCopy(rating);
    console.log('RATE OBJ',temp)
    temp[`${category}Rating`][index] = value;
    console.log("rating ", temp);
    setRating(temp);
  };

  const handleDisplayRendering=(category:string)=>  {  const updatedDisplayCategory = { ...displayCategory };
  updatedDisplayCategory[category] = !updatedDisplayCategory[category];
  setDisplayCategory(updatedDisplayCategory);}

  const handleInputChange = (category, index, value) => {
    var tempAns = deepCopy(answers);
    tempAns[category][index] = value;
    console.log("temp",tempAns)
    setAnswers(tempAns);
  };

  function validation(obj, obj2) {
    try {
      for (let key in obj) {
        if (obj[key].length !== obj2[key].length) {
          return false;
        }
      }
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          if(key!=='title'){
          if (
            !Array.isArray(obj[key]) ||
            obj[key].length === 0 ||
            obj[key].some(
              (item) => typeof item !== "string" || item.trim() === ""
            )
          ) {
            return false;
          }
        }}
      }
      
      return true;
    } catch {
      return false;
    }
  }


  const updateReviewStatus = async (status:string) => {
    let submissionDate = '';
    const currentDate = new Date();
    const formattedDate = formatDate(currentDate, 'YYYY-MM-DD');
    submissionDate = formattedDate;
    try {
      const dbRef = ref(db, `reviewAssignment/${review.id}`);
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        const reviewData = snapshot.val();
        var updates = {
          ...reviewData, 
          status: status
        };
        if(status==='Submitted')
          {
            updates.submissionDate=submissionDate;
          }
        await update(dbRef, updates);
        console.log("Review status updated successfully to 'submitted'");
      } else {
        console.error("No such review exists!");
      }
    } catch (error) {
      console.error("Error updating review status:", error);
    }
  };
  
  const handleSubmit = async () => {
    setShowLoader(true)
    console.log('ANS is ',answers)
    let submissionDate = '';
const currentDate = new Date();
const formattedDate = formatDateWithLocalTimeZone(currentDate, 'DD-MM-yyyy hh:mm');
submissionDate = formattedDate;
    if (validation(answers, questionsList)) {
      console.log("Answers:", answers);
      const result = {};
      for (let key in questionsList) {
          if(key!=='title'){
        result[key] = [];     
        let maxLength =questionsList[key].length
        for (let i = 0; i < maxLength; i++) {
          let entry = {
            question: questionsList[key][i] || "",  
            answer: answers[key]?answers[key][i]:"" || "", 
            rating: rating[`${key}Rating`]?rating[`${key}Rating`][i] || "":""   
            
          };
          result[key].push(entry);
        }}}
        const data = {
          submissionDate:submissionDate,
          result:result
        };
      try {
        const dbRef = ref(db, `reviewSubmission/${review.id}`);
        await set(dbRef, data).then(async() => {
        const assignmentRef = ref(db, `reviewAssignment/${review.id}`);
        const assignmentSnapshot = await get(assignmentRef);
        if (assignmentSnapshot.exists()) {
          const assignmentData = assignmentSnapshot.val();
          const updatedAssignmentData = {
            ...assignmentData,
            dueDate: getCurrentDate()
          };

          await update(assignmentRef, updatedAssignmentData);
        } else {
          console.error("No such review assignment exists!");
        }
          setShowLoader(false)
          setSubmissionToast(true);
          setToastMessage(`Review of ${review.ReviewedUserName} Submitted Successfully on ${submissionDate}`);
          setAnswers({})
          setRating({})
        });
      } catch {
        setShowLoader(false)
        console.log("Error");
        setSubmissionToast(true);
        setToastMessage("Error in Review Submission");
        setAnswers({})
        setRating({})
      }
    } else {
      setShowLoader(false)
      setSubmissionToast(true);
      setToastMessage("Please Fill All the Fields");
    }
  };

  const handleSaved = async () => {
    setShowLoader(true)
    let submissionDate = '';
const currentDate = new Date();
const formattedDate = formatDateWithLocalTimeZone(currentDate, 'DD-MM-YYYY hh:mm');
submissionDate = formattedDate;
      const result = {};
      for (let key in questionsList) {
          if(key!=='title'){
        result[key] = [];     
        let maxLength =questionsList[key].length
        for (let i = 0; i < maxLength; i++) {
          let entry = {
            question: questionsList[key][i] || "",  
            answer: answers[key][i] || "", 
            rating: rating[`${key}Rating`]?rating[`${key}Rating`][i] || "":""   
            
          };
          result[key].push(entry);
        }}}
        const data = {
          submissionDate:submissionDate,
          result:result
        };
      try {
        const dbRef = ref(db, `reviewSubmission/${review.id}`);
        await set(dbRef, data).then(() => {
          setShowLoader(false)
          setSubmissionToast(true);
          setToastMessage(`Review of ${review.ReviewedUserName} Saved Successfully on ${submissionDate}`);
          setAnswers({})
          setRating({})
        });
      } catch {
        setShowLoader(false)
        console.log("Error");
        setSubmissionToast(true);
        setToastMessage("Error in Review Save");
        setAnswers({})
        setRating({})
      }

  };


const fetchReviewSubmission = async (reviewId) => {
  setShowLoader(true)
  try {
    const dbRef = ref(db, `reviewSubmission/${reviewId}`, );
    const snapshot = await get(dbRef);
    if (snapshot.exists()) {
      const reviewData = snapshot.val().result;
      console.log('Submmited',reviewData)
      var questions={}
      var answersList={}
      var ratingList={}
for (const key in reviewData)
  {
    questions[key]=[]
    answersList[key]=[]
    ratingList[`${key}Rating`]=[]
    reviewData[key].forEach(item => {
      console.log('ITEM',item)
      questions[key].push(item.question)
      answersList[key].push(item.answer)
      ratingList[`${key}Rating`].push(item.rating)
    })
   
  }

  setRating(ratingList)
  setQuestionsList(questions)
  setAnswers(answersList)
      setReviewsResult(reviewData)
      const initialDisplayCategory = {};
      Object.keys(questions).forEach(key => {
        initialDisplayCategory[key] = true; 
      });
      setDisplayCategory(initialDisplayCategory);
  setShowLoader(false)
    }
  } catch (error) {
  setShowLoader(false)
    console.error("Error fetching document:", error);
    throw error;
  }
};

const handleOnDialogClose = () => {
  setSubmissionToast(false);
  if (toastMessage.includes('Submitted')) {
      updateReviewStatus('Submitted');
      navhelper.push("AdminReviewsScreen");
  } else if (toastMessage.includes('Saved')) {
      navhelper.goBack();
  }
};



  return (
    <div style={styles.outer}>
      <Menu />
      <div
        ref={scrollContainerRef}
        style={styles.scroll}
      >
        <div
          style={{
            width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "97%",
          }}
        >
          <div
            style={styles.topBar}
          >
         {mode==='Edit'?   'Review Submission':`Review of ${review.ReviewedUserName}`}
          </div>
          <div style={{display:'flex',flexDirection:screenWidth<=MOBILE_VIEW_WIDTH?'column':'row',justifyContent:'flex-start'}}>
          <div style={{width:screenWidth>MOBILE_VIEW_WIDTH?'50%':'100%'}}>
            {questionsList &&
              Object.keys(questionsList).map((category,index) => (
                <div key={category} >
                  <div style={styles.display}>
        {category!=='title'&&          <div
  style={styles.displaySecondary}
  onClick={() => {
handleDisplayRendering(category)
  }}
>
  {displayCategory[category]===true ? '- ':'+'}
</div>
}
                  <div>
                  {category !== "title" && <h2>{category}</h2>}
                  </div>
                  <div>
                    </div>
                    </div>
                  <div>
                    {category !== "title" &&(displayCategory[category]) &&questionsList[category]&& Array.isArray(questionsList[category])&&
                      questionsList[category].map((question, index) => (
                               <div key={index}>
                  <View
                            style={styles.applicable}
                          >
                          <View
                            style={styles.notApplicable}
                          >
                            <Text>Not Applicable</Text>
                            <input
                            disabled={mode==='Edit'?false:true}
                              type="checkbox"
                              checked={answers[category]?answers[category][index]==='N/A'?true:false:false}
                              onChange={(event) => {
                                console.log("Tick", event.target.checked);
                                if( event.target.checked)
                                  {
                                    const checkAnswer=deepCopy(answers);
                                    checkAnswer[category][index]='N/A'
                                    setAnswers(checkAnswer)
                                    const tempRating={...rating}
                                    tempRating[`${category}Rating`][index]="";
                                    setRating(tempRating)
                                  }
                                  else
                                  {
                                    const checkAnswer=deepCopy(answers);
                                    checkAnswer[category][index]=''
                                    setAnswers(checkAnswer)
                                  }
                              }}
                            />
                          </View>
                            <RatingField
                            viewMode={review.status==='In-Process'?false:true}
                            ratingAmount={rating[`${category}Rating`]?parseInt(rating[`${category}Rating`][index]):0}
                            enabled={mode==='Edit'?answers[category]?answers[category][index]==='N/A'?false:true:true:false}
                              lowLabel="1"
                              highLabel="5"
                              onRatingChange={onRatingChange}
                              question={category}
                              questionCode={index}
                            />
                          </View>

                          <div
                            style={styles.question}
                          >{`${index + 1}.  ${question}`}</div>

                          <TextInput
                            value={
                              answers && answers[category]
                                ? answers[category][index]
                                : ""
                            }
                            style={styles.textField}
                            placeholder="Enter your answer"
                            editable={mode==='Edit'?answers[category]?answers[category][index]==='N/A'?false:true:true:false}
                            onChangeText={(e) =>
                              handleInputChange(category, index, e)
                            }
                          />
                        </div>
                     
                      ))}
                  </div>  
                </div>
              ))}
                        {questionsList &&mode==='Edit'&& (
            <View style={styles.bottomBar}>
              <TouchableOpacity style={styles.submitButton} onPress={()=>{
                updateReviewStatus('Saved')
                handleSaved()
             //   navhelper.goBack()
                }}>
              <div style={styles.submitButtonText}>Save</div>
            </TouchableOpacity>
            <TouchableOpacity style={styles.submitButton} onPress={handleSubmit}>
              <div style={styles.submitButtonText}>Submit</div>
            </TouchableOpacity>
</View>
          )}
          </div>
          <div style={{width:screenWidth>MOBILE_VIEW_WIDTH?'50%':'96%',marginLeft:screenWidth>MOBILE_VIEW_WIDTH?10:0,marginTop:screenWidth>MOBILE_VIEW_WIDTH?0:20}}>
          <div style={styles.legendBox}>
          <h2>LEGENDS</h2>
          <div style={styles.starContainer}>
          <h3>Unacceptable</h3>
          <div>
          <div style={styles.starframe}>{renderStars(1)}</div>
          </div>
          </div>
          <div>Consistently fails to meet objectivees. Serious issues with quality and reliability.</div>
          <div style={styles.starContainer}>
          <h3>Needs Improvement</h3>
          <div>
          <div style={styles.starframe}>{renderStars(2)}</div>
          </div>
          </div>
          <div>Consistently fails to meet objectivees. Serious issues with quality and reliability.</div>
          <div style={styles.starContainer}>
          <h3>Satisfactory</h3>
          <div>
          <div style={styles.starframe}>{renderStars(3)}</div>
          </div>
          </div>
          <div>Assigned tasks are usually met. There are fewer issues. Some level of supervision and review efforts are required.</div>
          <div style={styles.starContainer}>
          <h3>Good</h3>
          <div>
          <div style={styles.starframe}>{renderStars(4)}</div>
          </div>
          </div>
          <div>Assigned Tasks are always completed on time with a good level of quality.</div>
          <div style={styles.starContainer}>
          <h3>Exceptional</h3>
          <div>
          <div style={styles.starframe}>{renderStars(5)}</div>
          </div>
          </div>
          <div>Outlier. Always exceeds all expectations relative to their skills and experience</div>
          </div>
          </div>
          </div>
          {review.status==='In-process'&&!questionsList && !showLoader && (
            <Dialog
              isDialogVisible={true}
              message="No Reviews Available Currently"
              onDialogClose={() => navhelper.goBack()}
            />
          )}
                 
          {showLoader && <Loader />}
          {showSubmissionToast && (
            <Dialog
              isDialogVisible={true}
              message={toastMessage}
              title="Review Submitted"

              onDialogClose={handleOnDialogClose}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewSubmissionScreen;
